import React, { useState, useEffect, useRef } from 'react';
import { Terminal, RefreshCw, Search, Trash2 } from 'lucide-react';

function SystemLogs({ token }) {
  const [logs, setLogs] = useState("");
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const scrollRef = useRef(null);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/logs', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setLogs(data.logs || "");
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => {
    fetchLogs();
    const interval = setInterval(fetchLogs, 10000); // Poll logs every 10s
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [logs]);

  const filteredLogs = logs.split('\n').filter(line => line.toLowerCase().includes(filter.toLowerCase())).join('\n');

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <div className="flex justify-between items-center bg-slate-900 p-8 rounded-[40px] border border-blue-500/10 shadow-xl">
        <div>
          <h3 className="text-2xl font-black text-white flex items-center gap-3"><Terminal className="text-indigo-400" /> Tizim Loglari</h3>
          <p className="text-slate-500 font-bold text-sm mt-1">Serverdagi barcha hodisalar va API so'rovlarini real vaqtda kuzatish</p>
        </div>
        <div className="flex gap-4">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18}/>
            <input
              type="text"
              placeholder="Qidirish (GET, POST, Error)..."
              className="pl-12 pr-6 py-4 bg-slate-950 border border-white/5 rounded-2xl w-64 outline-none focus:ring-2 focus:ring-indigo-500/20 font-bold text-xs text-white"
              value={filter}
              onChange={e => setFilter(e.target.value)}
            />
          </div>
          <button
            onClick={fetchLogs}
            disabled={loading}
            className="p-4 bg-white/5 text-slate-400 rounded-2xl hover:bg-indigo-600 hover:text-white transition active:rotate-180 duration-500"
          >
            <RefreshCw size={20} className={loading ? "animate-spin" : ""} />
          </button>
        </div>
      </div>

      <div className="bg-slate-950 rounded-[45px] border border-indigo-500/20 shadow-2xl overflow-hidden relative group">
        <div className="absolute top-6 left-10 flex gap-1.5">
          <div className="w-3 h-3 rounded-full bg-rose-500/50" />
          <div className="w-3 h-3 rounded-full bg-amber-500/50" />
          <div className="w-3 h-3 rounded-full bg-emerald-500/50" />
        </div>
        <div className="pt-16 pb-10 px-10">
          <pre
            ref={scrollRef}
            className="h-[600px] overflow-y-auto font-mono text-[11px] leading-relaxed text-slate-400 custom-scrollbar whitespace-pre-wrap"
          >
            {filteredLogs || "Hech qanday log topilmadi."}
          </pre>
        </div>
      </div>
    </div>
  );
}

export default SystemLogs;
